import Section from '../Section/Section'
import { ReadMore } from '../ReadMore/ReadMore'
import { ListingAgent } from './ListingAgent/ListingAgent'
import { Listing } from '../../../../api/gqlaxy/gql/generated/graphql'
import { ListingMetadata } from '../../Compliance/ListingMetadata/ListingMetadata'
import { Waypoint } from 'react-waypoint'
import { useTrackingContext } from '../../../../providers/tracking'
import { useTrackingDebounceSetters } from '../../../../hooks/tracking'
import { LISTINGS_DETAILED, LISTING_DESCRIPTION } from '../../../../constants/tracking/trackingEventConstants'
import { Box } from '@homebotapp/hb-react-component-catalog'

export interface DescriptionProps {
  listing?: Listing
  propertyDescriptionRef?: React.RefObject<HTMLDivElement>
}

export const Description = ({ listing, propertyDescriptionRef }: DescriptionProps) => {
  const { trackingClient } = useTrackingContext()
  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        event_source: LISTINGS_DETAILED,
        module_name: LISTING_DESCRIPTION
      })
  )
  return (
    <Section>
      <Section.Body>
        <Box ref={propertyDescriptionRef}>
          {listing?.description && <ReadMore text={listing.description} truncateCount={500} />}
        </Box>
        <Waypoint onEnter={() => trackModuleViewed()} bottomOffset='25%' />
        <hr />
        <ListingAgent listing={listing} />
        <ListingMetadata hideDisclaimer={true} listing={listing} />
      </Section.Body>
    </Section>
  )
}
